/**
 * Filtro de Categorías Moderno
 * Funcionalidad para scroll suave y filtrado de categorías
 */

(function($) {
    'use strict';

    // Configuración
    const CONFIG = {
        scrollOffset: 100, // Offset para el scroll
        animationDuration: 800, // Duración de la animación
        activeClass: 'active',
        filterSelector: '.filter-item',
        linkSelector: '.scroll-link',
        categorySelector: '.gallery-category-header'
    };

    class CategoryFilter {
        constructor() {
            this.init();
        }

        init() {
            this.bindEvents();
            this.setupSmoothScroll();
            this.setupActiveState();
        }

        bindEvents() {
            // Click en los enlaces del filtro
            $(CONFIG.linkSelector).on('click', (e) => {
                e.preventDefault();
                this.handleFilterClick(e);
            });

            // Click en el botón back-to-filter
            $('.back-to-filter').on('click', (e) => {
                e.preventDefault();
                this.handleBackToFilterClick(e);
            });

            // Scroll para actualizar el estado activo
            $(window).on('scroll', () => {
                this.updateActiveState();
            });

            // Resize para recalcular posiciones
            $(window).on('resize', () => {
                this.updateActiveState();
            });
        }

        handleFilterClick(e) {
            const $link = $(e.currentTarget);
            const targetId = $link.attr('href');
            
            // Actualizar estado activo
            this.setActiveFilter($link);
            
            // Scroll suave
            if (targetId && targetId !== '#') {
                this.smoothScrollTo(targetId);
            }
        }

        handleBackToFilterClick(e) {
            const $link = $(e.currentTarget);
            const targetId = $link.attr('href');
            
            // Scroll suave hacia el filtro con offset adicional de 150px
            if (targetId && targetId !== '#') {
                this.smoothScrollToWithOffset(targetId, 150);
            }
        }

        smoothScrollTo(targetId) {
            const $target = $(targetId);
            
            if ($target.length) {
                const targetOffset = $target.offset().top - CONFIG.scrollOffset;
                
                $('html, body').animate({
                    scrollTop: targetOffset
                }, CONFIG.animationDuration, 'easeInOutCubic');
            }
        }

        smoothScrollToWithOffset(targetId, customOffset) {
            const $target = $(targetId);
            
            if ($target.length) {
                const targetOffset = $target.offset().top - customOffset;
                
                $('html, body').animate({
                    scrollTop: targetOffset
                }, CONFIG.animationDuration, 'easeInOutCubic');
            }
        }

        setupSmoothScroll() {
            // Agregar easing personalizado si no existe
            if (!$.easing.easeInOutCubic) {
                $.easing.easeInOutCubic = function (x, t, b, c, d) {
                    if ((t/=d/2) < 1) return c/2*t*t*t + b;
                    return c/2*((t-=2)*t*t + 2) + b;
                };
            }
        }

        setActiveFilter($link) {
            // Remover clase activa de todos los filtros
            $(CONFIG.filterSelector).removeClass(CONFIG.activeClass);
            
            // Agregar clase activa al filtro clickeado
            $link.closest(CONFIG.filterSelector).addClass(CONFIG.activeClass);
        }

        setupActiveState() {
            // Configurar estado inicial
            this.updateActiveState();
        }

        updateActiveState() {
            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();
            const documentHeight = $(document).height();
            
            // Encontrar la sección más cercana al scroll
            let $closestSection = null;
            let closestDistance = Infinity;
            
            $(CONFIG.categorySelector).each((index, element) => {
                const $section = $(element);
                const sectionTop = $section.offset().top;
                const sectionHeight = $section.outerHeight();
                const sectionCenter = sectionTop + (sectionHeight / 2);
                
                // Calcular distancia desde el centro de la ventana
                const windowCenter = scrollTop + (windowHeight / 2);
                const distance = Math.abs(sectionCenter - windowCenter);
                
                if (distance < closestDistance) {
                    closestDistance = distance;
                    $closestSection = $section;
                }
            });
            
            // Actualizar filtro activo basado en la sección visible
            if ($closestSection && $closestSection.length) {
                const sectionId = $closestSection.attr('id');
                if (sectionId) {
                    const $correspondingFilter = $(`${CONFIG.linkSelector}[href="#${sectionId}"]`);
                    if ($correspondingFilter.length) {
                        this.setActiveFilter($correspondingFilter);
                    }
                }
            }
        }

        // Método público para filtrar por categoría específica
        filterByCategory(categoryId) {
            const $filter = $(`${CONFIG.linkSelector}[data-category="${categoryId}"]`);
            if ($filter.length) {
                $filter.trigger('click');
            }
        }

        // Método público para mostrar todas las categorías
        showAllCategories() {
            const $allFilter = $(`${CONFIG.linkSelector}[data-category="all"]`);
            if ($allFilter.length) {
                $allFilter.trigger('click');
            }
        }
    }

    // Inicializar cuando el documento esté listo
    $(document).ready(function() {
        // Verificar que los elementos necesarios existan
        if ($(CONFIG.filterSelector).length && $(CONFIG.linkSelector).length) {
            window.categoryFilter = new CategoryFilter();
            
            // Agregar efectos adicionales
            addHoverEffects();
            addLoadingAnimation();
        }
    });

    // Efectos de hover mejorados
    function addHoverEffects() {
        $(CONFIG.filterSelector).each(function() {
            const $item = $(this);
            const $link = $item.find(CONFIG.linkSelector);
            
            $link.on('mouseenter', function() {
                $item.addClass('hover-effect');
            }).on('mouseleave', function() {
                $item.removeClass('hover-effect');
            });
        });
    }

    // Animación de carga
    function addLoadingAnimation() {
        // Agregar clase de carga inicial
        $('body').addClass('filter-loading');
        
        // Remover después de un tiempo
        setTimeout(() => {
            $('body').removeClass('filter-loading');
        }, 1000);
    }

    // Utilidades adicionales
    const FilterUtils = {
        // Obtener categoría activa
        getActiveCategory: function() {
            const $active = $(`${CONFIG.filterSelector}.${CONFIG.activeClass}`);
            return $active.find(CONFIG.linkSelector).data('category');
        },
        
        // Obtener todas las categorías
        getAllCategories: function() {
            const categories = [];
            $(CONFIG.filterSelector).each(function() {
                const category = $(this).find(CONFIG.linkSelector).data('category');
                if (category) {
                    categories.push(category);
                }
            });
            return categories;
        },
        
        // Scroll a la parte superior
        scrollToTop: function() {
            $('html, body').animate({
                scrollTop: 0
            }, CONFIG.animationDuration);
        }
    };

    // Exponer utilidades globalmente
    window.FilterUtils = FilterUtils;

})(jQuery);
